"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addItem = void 0;
var actions = {
    ADD_ITEM: 'breadcrumb/ADD_ITEM',
    SET_STATE: 'breadcrumb/SET_STATE',
    GET_STATE: 'breadcrumb/GET_STATE',
};
exports.addItem = function (key, value) {
    return {
        type: actions.ADD_ITEM,
        payload: {
            key: key,
            value: value,
        },
    };
};
exports.default = actions;
//# sourceMappingURL=actions.js.map